import { motion } from "framer-motion";
import { BookOpen, LineChart, MousePointerClick, RefreshCw } from "lucide-react";

const steps = [
  { icon: MousePointerClick, title: "Buy / Access planner", text: "Start with the physical planner or unlock the digital dashboard." },
  { icon: BookOpen, title: "Use planner pages", text: "Plan days, habits, goals, and reflections on pages that feel intentional." },
  { icon: LineChart, title: "Track digitally", text: "Save progress, enquiries, uploads, and routines inside the dashboard." },
  { icon: RefreshCw, title: "Improve daily", text: "Use weekly review loops to make your next week cleaner than this one." },
];

export default function HowItWorks() {
  return (
    <section id="how" className="bg-[#F8F2E8] px-5 py-20 md:px-10">
      <div className="mx-auto max-w-7xl">
        <div className="mb-12 text-center">
          <p className="font-body text-sm font-bold uppercase tracking-[0.28em] text-[#C99455]">How it works</p>
          <h2 className="mx-auto mt-3 max-w-4xl font-heading text-4xl uppercase leading-none text-[#073C2F] md:text-6xl">
            Four steps from intention to visible growth.
          </h2>
        </div>
        <div className="grid gap-5 md:grid-cols-4">
          {steps.map((step, index) => (
            <motion.article
              key={step.title}
              className="relative rounded-lg border border-[#D5AD76] bg-[#FBF7EF] p-6 text-[#073C2F] shadow-[0_14px_45px_rgba(7,60,47,0.08)]"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: index * 0.05 }}
            >
              <span className="absolute right-5 top-5 font-heading text-5xl text-[#D5AD76]/40">0{index + 1}</span>
              <div className="mb-10 grid h-12 w-12 place-items-center rounded-full bg-[#073C2F] text-[#FBF7EF]">
                <step.icon size={22} />
              </div>
              <h3 className="font-heading text-xl uppercase">{step.title}</h3>
              <p className="mt-3 font-body text-sm leading-6 text-[#27463B]/82">{step.text}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
